import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Button, Text } from '@adsk/bim360-matrix-react-components';

class IssuePreviewNoWorkflowConfiguration extends PureComponent {

  render() {
    const { closePopup } = this.props;
    return (
      <div className="IssuePreviewNoWorkflowConfiguration">
        <div className="IssuePreviewNoWorkflowConfiguration__content">
          <div className="IssuePreviewNoWorkflowConfiguration__title">
            <Text>{T.translate('transition.workflowConfigurationError.title')}</Text>
          </div>
          <div className="IssuePreviewNoWorkflowConfiguration__message">
            <Text>{T.translate('transition.workflowConfigurationError.message')}</Text>
          </div>
        </div>

        <div className="IssuePreviewNoWorkflowConfiguration__footer">
          <Button
            styleType={Button.StyleType.PRIMARY}
            className="IssuePreviewNoWorkflowConfiguration__close-button"
            onClick={closePopup}
          >
            {T.translate('navigation.close')}
          </Button>
        </div>
      </div>
    );
  }
}

IssuePreviewNoWorkflowConfiguration.displayName = 'IssuePreviewNoWorkflowConfiguration';

IssuePreviewNoWorkflowConfiguration.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default IssuePreviewNoWorkflowConfiguration;
